<template>
  <div class="comp-quotes">
    <h1 class="headline">QUOTES</h1>

    <div class="toolbar">
      <div class="btns">
        <button type="button" class="btn btn-outline-black w180" @click="showModalAdd = true">+ New Quote</button>
      </div>

      <div class="filters">
        <div class="input-search">
          <input type="text" name="s" class="form-control" placeholder="SEARCH QUOTES..." v-model="keyword" @change="getQuotes()">
        </div>
        <v-select v-model="ftStatus" :options="statusOpts" class="ft-type" :reduce="item => item.value"
                  :searchable="false" :placeholder="'STATUS'"></v-select>
        <v-select v-model="ftClient" :options="allClients" class="ft-client" :reduce="item => item.id"
                  label="name" :searchable="true"  placeholder="ALL CLIENTS"></v-select>
        <v-select v-model="ftManager" :options="allManagers" class="ft-manager" :reduce="item => item.id"
          label="full_name" :searchable="true" placeholder="ALL MANAGERS"></v-select>
        <date-picker format="DD-MM-YYYY" v-model="ftDateRange" :range="true" :editable="false"
                     placeholder="DATE RANGE"></date-picker>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th width="90"><a href="javascript:;" data-sort-field="quote_number" @click="doSort($event)" class="sort">QUOTE NO</a></th>
            <th><a href="javascript:;" data-sort-field="client_name" @click="doSort($event)" class="sort">CLIENT</a></th>
            <th><a href="javascript:;" data-sort-field="name" @click="doSort($event)" class="sort">QUOTE NAME</a></th>
            <th><a href="javascript:;">CREATED BY</a></th>
            <th width="150"><a href="javascript:;" data-sort-field="status" @click="doSort($event)" class="sort">STATUS</a></th>
            <!--
            <th><a href="javascript:;" data-sort-field="status_date" @click="doSort($event)" class="sort desc">DATE</a></th>
            !-->

            <th width="120"><a href="javascript:;" data-sort-field="total_value" @click="doSort($event)" class="sort">QUOTE VALUE</a></th>
            <th width="40"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(quote, index) in quotes" :key="index" >
            <td>
              <router-link :to="{ name: 'quote', params: { quoteId: quote.id } }" class="black">{{ quote.quote_number }}</router-link>
            </td>
            <td><router-link :to="{ name: 'client', params: { itemId: quote.client.id } }" class="black">{{ quote.client.name }}</router-link></td>
            <td>
              <router-link :to="{ name: 'quote', params: { quoteId: quote.id } }" class="black">{{ quote.name }}</router-link>
            </td>
            <td><router-link :to="{ name: 'quote', params: { quoteId: quote.id } }" class="black">{{ quote.creator?quote.creator.full_name:'' }}</router-link></td>
            <td>
              <v-select v-on:input="updateStatus(quote.status, index)" v-model="quote.status" :options="statusOpts" class="status" :reduce="item => item.value" :clearable="false" :searchable="false"></v-select>
            </td>
            <!--
            <td><router-link :to="{ name: 'quote', params: { quoteId: quote.id } }" class="black">{{ quote.status_date | toHumanDate('Do MMM YYYY') }}</router-link></td>
            !-->
            <td><router-link :to="{ name: 'quote', params: { quoteId: quote.id } }" class="black">{{ quote.total_value | moneyFormat }}</router-link></td>
            <td class="text-right actions">
              <a href="javascript:;" class="icon-copy" v-tooltip="'Duplicate quote'"
                 @click="confDuplicate(index)"></a>&nbsp;
              <a href="javascript:;" class="icon-trash" v-tooltip="'Delete quote'"
                 @click="confDelete(index)"></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="hasFilters && totalItems == 0" class="alert alert-warning">
      No quotes found
    </div>

    <modal-add-quote v-model="showModalAdd" @added="onQuoteAdded"></modal-add-quote>

    <div v-if="IS_SUPER_ADMIN" class="footbar">
      <div class="container">
        <div class="inn">
          <label class="lb">TOTAL QUOTES</label>
          <span class="total">{{ totalItems }} | {{ totalQuoteValue | moneyFormat(0) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ServiceQuote from '@/services/quote'
import ModalAddQuote from './ModalAddQuote'
import ModalDuplicate from './ModalDuplicate';

import DatePicker from 'vue2-datepicker';
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import jquery from "jquery"
// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

dayjs.extend(relativeTime)
dayjs.extend(advancedFormat)

export default {
  components: {
    ModalAddQuote,
    DatePicker
  },
  data () {
    return {
      showModalAdd: false,
      keyword: '',
      activeIndex: -1,
      ftStatus: '',
      ftClient: '',
      ftManager: '',
      ftDateRange: '',
      quotes: [],
      totalItems: 0,
      excluding_statuses: ['cancelled', 'completed'],
      sort: 'status_date',
      order: 'desc'
    }
  },
  watch: {
    ftStatus: function () {
      this.getQuotes();
    },
    ftClient: function () {
      this.getQuotes();
    },
    ftManager: function () {
      this.getQuotes();
    },
    ftDateRange: function () {
      this.getQuotes();
    }
  },
  computed: {
    ...mapGetters(['IS_SUPER_ADMIN']),
    ...mapState({
      allClients: state => state.option.clients,
      quoteStatuses: state => state.option.quoteStatuses,
      allManagers: function(state){
        let managers = [];
        for(let i in state.option.users){
          if(state.option.users[i].user_type_id == window.USER_MANAGER_TYPE_ID)
            managers.push(state.option.users[i])
        }
        return managers;
      },
    }),
    statusOpts () {
      let self = this, opts = [];
      for(var i in self.quoteStatuses){
        opts.push({label: window.stringToUCWords(self.quoteStatuses[i]), value: self.quoteStatuses[i]});
      }
      return opts;
    },
    hasFilters () {
      let self = this;
      return self.ftStatus != '' || self.ftClient != '' || self.ftManager != ''  || self.ftDateRange != '' || self.keyword != '';
    },
    totalQuoteValue () {
      let self = this, total = 0;
      for(var i in self.quotes){
        total += parseFloat(self.quotes[i].total_value);
      }
      return total;
    },
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.showModalAdd = false;
      this.getQuotes();
    },
    confDuplicate ( index ) {
      let self = this;
      self.$modal.show(ModalDuplicate, {
        index: index,
        quote: self.quotes[index]
      }, {
        clickToClose: false,
        width: 592
      });
    },
    onQuoteAdded ( quote ) {
      let self = this;
      self.$router.push({
        name: 'quote',
        params: {
          quoteId: quote.id
        }
      });
    },
    confDelete ( index ) {
      let self = this, item = self.quotes[index];
      self.$dialog
        .confirm('Are you sure you want to delete quote <strong>' + item.name + '</strong>?', {
          html: true,
          loader: true,
          okText: "Yes, I'm sure",
          cancelText: "Cancel",
        })
        .then(dialog => {
          ServiceQuote.delete(item.id, () => {
            dialog.close();
            if (typeof self.quotes == 'object')
              delete self.quotes[index];
            else
              self.quotes.splice(index, 1);
            self.totalItems--;
            self.$notify({
              type: 'success',
              text: 'Quote <strong>' + item.name + '</strong> has been deleted'
            });
          });
        })
        .catch(() => {})
      ;
    },
    doPaging ( ) {
      let self = this;
      self.getQuotes();
    },
    _getParams () {
      let self = this,
        params = {
          ipp: 'all'
        };

      if ( self.ftStatus !== '' ) {
        params.status = self.ftStatus;
      }
      if (!self.ftStatus) {
        /* Exclude all 'Completed' quotes */
        params.exclude_status = self.excluding_statuses;
      }
      if ( self.ftClient !== '' ) {
        params.client_id = self.ftClient;
      }
      if ( self.ftManager !== '' ) {
        params.manager_id = self.ftManager;
      }
      if ( self.ftDateRange !== '' && self.ftDateRange.length == 2 && self.ftDateRange[0] && self.ftDateRange[1]) {
        params.date_start = dayjs(self.ftDateRange[0]).format('YYYY-MM-DD');
        params.date_end = dayjs(self.ftDateRange[1]).format('YYYY-MM-DD');
      }
      if ( self.keyword !== '' ) {
        params.kw = self.keyword;
      }
      params['sort'] = self.sort;
      params['order'] = self.order;
      return params;
    },
    getQuotes () {
      let self = this, params = self._getParams();

      self.state = 'loading';
      ServiceQuote.getQuotes(params, resp => {
        self.state = 'loaded';
        self.quotes = resp;
        self.totalItems = window.numkeys(self.quotes);
      });
    },
    printWIP(){
      let self = this;
      let params = self._getParams();

      self.status = 'loading';
      ServiceQuote.printWIP(params, resp => {
        self.status = '';
        window.downloadFromBlob(resp.data, 'quotes_wip.pdf');
      }, () => {
        self.status = '';
      });
    },
    gotoQuote(quoteId) {
      this.$router.push({name: 'quote', params: {quoteId: quoteId}});
    },
    doSort (event) {
      let self = this, params = self._getParams(), header = event.target;

      // Go through all header and reset the sort class
      jquery('.sort').not(header).attr('class', 'sort');

      if (typeof header.dataset.sortField != 'undefined') {
        params['sort'] = header.dataset.sortField;
        if (header.className.indexOf('asc') == -1) {
          /* Not sort or in desc */
          params['order'] = 'asc';
          header.className = header.className.replace(' desc', '') + ' asc';
        } else if (header.className.indexOf('desc') == -1) {
          params['order'] = 'desc';
          header.className = header.className.replace(' asc', '') + ' desc';
        }
        self.sort = params['sort'];
        self.order = params['order'];
        self.state = 'loading';
        ServiceQuote.getQuotes(params, resp => {
          self.state = 'loaded';
          self.quotes = resp;
          self.totalItems = window.numkeys(self.quotes);
        });
      }
    },
    updateStatus (oldStatus, index) {
      let self = this, item = self.quotes[index];
      ServiceQuote.save(item.id, {status: item.status}, function() {
        self.$notify({
          type: 'success',
          text: 'Quote updated'
        });
      });
    },
  }
}
</script>
